/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BuchungsschluesselDto } from '../models/buchungsschluessel-dto';
import { getAllBuchungsschluessel$Json } from '../fn/buchungsschluessel/get-all-buchungsschluessel-json';
import { GetAllBuchungsschluessel$Json$Params } from '../fn/buchungsschluessel/get-all-buchungsschluessel-json';
import { getAllBuchungsschluessel$Plain } from '../fn/buchungsschluessel/get-all-buchungsschluessel-plain';
import { GetAllBuchungsschluessel$Plain$Params } from '../fn/buchungsschluessel/get-all-buchungsschluessel-plain';

@Injectable({ providedIn: 'root' })
export class BuchungsschluesselApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllBuchungsschluessel()` */
  static readonly GetAllBuchungsschluesselPath = '/v1/buchungsschluessel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllBuchungsschluessel$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBuchungsschluessel$Plain$Response(params?: GetAllBuchungsschluessel$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungsschluesselDto>>> {
    return getAllBuchungsschluessel$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllBuchungsschluessel$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBuchungsschluessel$Plain(params?: GetAllBuchungsschluessel$Plain$Params, context?: HttpContext): Observable<Array<BuchungsschluesselDto>> {
    return this.getAllBuchungsschluessel$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungsschluesselDto>>): Array<BuchungsschluesselDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllBuchungsschluessel$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBuchungsschluessel$Json$Response(params?: GetAllBuchungsschluessel$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungsschluesselDto>>> {
    return getAllBuchungsschluessel$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllBuchungsschluessel$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllBuchungsschluessel$Json(params?: GetAllBuchungsschluessel$Json$Params, context?: HttpContext): Observable<Array<BuchungsschluesselDto>> {
    return this.getAllBuchungsschluessel$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungsschluesselDto>>): Array<BuchungsschluesselDto> => r.body)
    );
  }

}
